import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { Router,ActivatedRoute,ParamMap,NavigationExtras } from "@angular/router";

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiDtgCarService
} from "src/app/shared/service";
import {
    PagingInfo
} from "src/app/shared/vo";

@Component({
    templateUrl: "./dtg.manage.car.ext.accept.modal.search.company.component.html"
    ,styleUrls: ["./dtg.manage.car.ext.accept.modal.search.company.component.scss"]
    ,providers: []
})
export class DtgManageCarExtAcceptModalSearchCompanyComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    @Input() dtgUnitId:string;
    listItems:any[];
    pagingInfo:PagingInfo = new PagingInfo();
    searchValue:string;

    constructor(
        private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsCommonService:FvmsCommonService
        ,private router: Router
        ,private fvmsApiDtgCarService:FvmsApiDtgCarService
        ,public activeModal: NgbActiveModal
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.pagingInfo.pageSize = 10;
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                if(companyInfo){
                    if(this.companyInfo){
                        if(this.companyInfo.companyId !== companyInfo.companyId){
                            //회사가 바뀌면 차량 목록이 다르므로 메인 페이지로 이동해야 함
                            let tmpParam = {
                                runtime:new Date().getTime()
                            };
                            let navigationExtras:NavigationExtras = {
                                queryParams:tmpParam
                            };
                            this.router.navigate(["/dtg/manage/car/main"],navigationExtras);
                        }
                    }else{
                        this.companyInfo = companyInfo;
                        this.reloadListItems();
                    }
                }
            });
    }

    ngOnInit() {
        this.reloadListItems();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}

    clickSave(){
        this.activeModal.close({
            "result":"ok"
        });
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    reloadListItems(){
        let searchInfo = {
            companyId:this.companyInfo.companyId
            ,dtgUnitId:this.dtgUnitId
            ,searchValue:this.searchValue
        };
        this.fvmsApiDtgCarService.findAllCompanyExtAcceptNotExists(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listItems = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    clickSearch(){
        this.reloadListItems();
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItems();
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItems();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    clickSelectCompany(companyInfo:any){
        let searchInfo = {
            companyId:companyInfo.companyId
            ,dtgUnitId:this.dtgUnitId
            ,useYn:"Y"
        };
        this.fvmsApiDtgCarService.upsertDeviceCompanyExtAccept(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.clickSave();
                }
            });
    }
}